import {MODAL_TYPE} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import type {PlaceholderCreation} from './useAIChatStream';

// Mirrors the payload PlaceholderModal.js sends when opening the allocation
// modal after an in-app placeholder creation. placeholderInput carries only
// {id}: with staffingModeActive false the conductor's query sets
// loadPlaceholder and the modal reads the placeholder from the query response
// (store-and-network), so an MCP-created placeholder that never entered the
// Relay store is still found. projectGroupId is omitted — chat placeholder
// creation is project-scoped.
export function placeholderAllocationModalPayload(data: PlaceholderCreation): {
	type: string;
	projectId: string;
	isFromCreatePlaceholder: boolean;
	staffingModeActive: boolean;
	placeholderInput: {id: string};
} {
	return {
		type: MODAL_TYPE.PLACEHOLDER_ALLOCATION,
		projectId: data.projectId,
		isFromCreatePlaceholder: true,
		staffingModeActive: false,
		placeholderInput: {id: data.placeholderId},
	};
}
